const packageJson = require("../../package.json");
const appVersion = packageJson.version;
const apiVersion = packageJson.apiVersion;

export const environment = {
  production: true,
  isLocal: false,
  name: "PROD",
  auth2FA: false,
  baseAdminUrl: "https://soupisy.galeriekodl.cz",
  baseApiUrl: "https://api.soupisy.galeriekodl.cz",
  cdnUrl: "https://inventories.cdn.galeriekodl.cz",
  appVersion,
  apiVersion,
};
